import {
  appendAddSchOrder,
  cancelPlan,
  checkDispatchDeliverNeedConfirm,
  createScheduInfoSave,
  deliverInit,
  deliverSubmit,
  deliverSubmitWithCheck,
  editPlanInitPage,
  editSubmit,
  exportData,
  fileDownLoad,
  orderTrajectory,
  pageInfo,
  planCreatePreCheck,
  planEditPreCheck,
  queryAppointmentTableData,
  scheduleInfoPlanOnload,
  schedulingJobBillList,
  scheduTotalRefresh,
  shipInit,
  shipSubmit,
  uploadFile,
  updateCarrierInit,
  updateCarrierSubmit,
} from './../api'
import { addData } from '../../../mdm/truck/api'
import { addDriverData } from '../../../mdm/driver/api'
import {
  getCarTypeList,
  getDriverListByCarrierNo,
  getListCarrier,
  getTruckListByCarrierNo,
  listShipper,
  getPlateColor, getListShipType
} from '../../../../api'

const transportPlan = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    appointmentTotal: 0,
    appointmentPageResp: null,
    createScheduinfoSaveObj: null,//调度-新增保存
    editInitObj: null,
    editObj: null,
    editCheckObj: null,
    uploadFileObj: null,
    shipObj: null,
    deliverObj: null,
    shipSaveObj: null,
    deliverySaveObj: null,
    deliverCheckObj: null,
    cancelObj: null,
    exportObj: null,
    carrierObj: null,
    orderTrajectoryObj: null,
    carTypeDataResp: null,
    addValidateParamResp: null,
    fileDownloadObj: null,
    shipCodeObj: null,
    pageOrderResp: null,
    pageOrderTotal: null,
    orderValidate: null,
    planOnloadObj: null,
    scheduTotalObj: null,
    plateColorObj: null,
    shipTypeObj: null,
    updateCarrierInitObj: null,
    updateCarrierObj: null,
    dateCheckObj: null,
  },
  mutations: {

    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []);
    },
    //查询可预约的订单
    QUERY_APPOINTMENT_TABLE_DATA(state, data) {
      state.appointmentTotal = data.total;
      state.appointmentPageResp = data.obj;
    },

    //新增调度-保存提交
    CREATE_SCHEDUINFO_SAVE(state, data) {
      state.createScheduinfoSaveObj = data;
    },

    //点击编辑按钮-校验
    PLAN_EDIT_PRE_CHECK(state, data) {
      state.editCheckObj = data;
    },

    EDIT_INIT(state, data) {
      state.editInitObj = data;
    },
    EDIT_SUBMIT(state, data) {
      state.editObj = data;
    },
    SAVE_TRUCK_DATA(state, data) {
      state.saveTruckResp = data;
    },
    SAVE_DRIVER_DATA(state, data) {
      state.saveDriverResp = data;
    },
    TRUCK_LIST_BY_CARRIERNO(state, data) {
      state.truckDataResp = data.obj;
    },
    DRIVER_LIST_BY_CARRIERNO(state, data) {
      state.driverDataResp = data.obj;
    },
    //上传附件
    UPLOAD_FILE(state, data) {
      state.uploadFileObj = data;
    },
    /**
     * 发运初始化
     * @param state
     * @param data
     * @constructor
     */
    SHIP_INIT(state, data) {
      state.shipObj = data;
    },
    /**
     * 送达初始化
     * @param state
     * @param data
     * @constructor
     */
    DELIVER_INIT(state, data) {
      state.deliverObj = data;
    },
    /**
     * 发运提交
     * @param state
     * @param data
     * @constructor
     */
    SHIP_SUBMIT(state, data) {
      state.shipSaveObj = data;
    },
    /**
     * 送达提交
     * @param state
     * @param data
     * @constructor
     */
    DELIVER_SUBMIT(state, data) {
      state.deliverySaveObj = data;
    },
    /**
     * 送达提交（带GPS校验）
     * @param state
     * @param data
     * @constructor
     */
    DELIVER_SUBMIT_WITH_CHECK(state, data) {
      state.deliverCheckObj = data;
    },

    /**
     * 取消
     * @param state
     * @param data
     * @constructor
     */
    CANCEL_PLAN(state, data) {
      state.cancelObj = data;
    },
    /**
     * 导出
     * @param state
     * @param data
     * @constructor
     */
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    //承运商下拉框数据
    GET_LIST_CARRIER(state, data) {
      state.carrierObj = data.obj;
    },
    ORDER_TRAJECTORY(state,data) {
      state.orderTrajectoryObj = data.obj || {};
    },
    CAR_TYPE_LIST(state, data) {
      state.carTypeDataResp = data.obj;
    },
    ADD_VALIDATE_PARAM(state, data) {
      state.addValidateParamResp = data;
    },
    //文件下载
    FILE_DOWNLOAD(state, data){
      state.fileDownloadObj = data;
    },
    //货主
    LIST_SHIPPER(state, data) {
      state.shipCodeObj = data.obj;
    },
    LIST_PLATE_COLOR(state, data) {
      state.plateColorObj = data.obj;
    },
    /**
     * 调度-订单查询-分页
     * @param state
     * @param data
     * @constructor
     */
    SCHEDULING_JOB_BILL_LIST(state, data) {
      state.pageOrderTotal = data.total;
      state.pageOrderResp = (data.obj || [])
    },
    /**
     * 增加订单校验
     * @param state
     * @param data
     * @constructor
     */
    APPEND_ADD_SCH_ORDER(state, data) {
      state.orderValidate = data;
    },

    /**
     * 计划装载量
     * @param state
     * @param data
     * @constructor
     */
    SCHEDULEINFO_PLAN_ONLOAD(state, data) {
      state.planOnloadObj = data;
    },

    /**
     * 重新计算汇总~调度
     * @param state
     * @param data
     * @constructor
     */
    SCHEDU_TOTAL_REFRESH(state, data) {
      state.scheduTotalObj = data;
    },
    //运输方式下拉框数据
    GET_LIST_SHIP_TYPE(state, data) {
      state.shipTypeObj = data.obj;
    },
    /**
     * 更改承运商初始化
     * @param state
     * @param data
     * @constructor
     */
    UPDATE_CARRIER_INIT(state, data) {
      state.updateCarrierInitObj = data;
    },
    /**
     * 更改承运商提交
     * @param state
     * @param data
     * @constructor
     */
    UPDATE_CARRIER_SUBMIT(state, data) {
      state.updateCarrierObj = data;
    },

    /**
     * 发运/送达日期校验
     */
    CHECK_DISPATCH_DELIVER_NEED_CONFIRM(state, data) {
      state.dateCheckObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },

    //查询可预约的订单tableData
    async queryAppointmentTableData({ commit }, obj) {
      let resp = await queryAppointmentTableData(obj);
      commit('QUERY_APPOINTMENT_TABLE_DATA', resp);
    },

    //新增调度-保存提交
    async createScheduInfoSave({ commit }, obj) {
      let resp = await createScheduInfoSave(obj);
      commit('CREATE_SCHEDUINFO_SAVE', resp);
    },

    /**
     * 编辑初始化
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async editPlanInitPage({ commit }, obj) {
      let resp = await editPlanInitPage(obj);
      commit('EDIT_INIT', resp);
    },

    /**
     * 编辑提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async editSubmit({ commit }, obj) {
      let resp = await editSubmit(obj);
      commit('EDIT_SUBMIT', resp);
    },

    /**
     * 点击编辑校验
     */
    async planEditPreCheck({ commit }, obj) {
      let resp = await planEditPreCheck(obj);
      commit('PLAN_EDIT_PRE_CHECK', resp);
    },
    /**
     * 保存车辆
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async saveTruckData({ commit }, obj) {
      let resp = await addData(obj);
      commit('SAVE_TRUCK_DATA', resp);
    },
    /**
     * 保存司机
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async saveDriverData({ commit }, obj) {
      let resp = await addDriverData(obj);
      commit('SAVE_DRIVER_DATA', resp);
    },

    /**
     * 获取车辆信息
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getTruckListByCarrierNo({ commit }, obj) {
      let resp = await getTruckListByCarrierNo(obj);
      commit('TRUCK_LIST_BY_CARRIERNO', resp);
    },
    /**
     * 获取司机信息
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getDriverListByCarrierNo({ commit }, obj) {
      let resp = await getDriverListByCarrierNo(obj);
      commit('DRIVER_LIST_BY_CARRIERNO', resp);
    },

    /**
     * 上传附件
     */
    async uploadFile({commit}, obj) {
      let resp = await uploadFile(obj);
      commit('UPLOAD_FILE', resp);
    },

    /**
     * 发运初始化
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async shipInit({commit}, obj) {
      let resp = await shipInit(obj);
      commit('SHIP_INIT', resp);
    },
    /**
     * 送达初始化
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async deliverInit({commit}, obj) {
      let resp = await deliverInit(obj);
      commit('DELIVER_INIT', resp);
    },

    /**
     * 发运提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async shipSubmit({commit}, obj) {
      let resp = await shipSubmit(obj);
      commit('SHIP_SUBMIT', resp);
    },
    /**
     * 送达提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async deliverSubmit({commit}, obj) {
      let resp = await deliverSubmit(obj);
      commit('DELIVER_SUBMIT', resp);
    },
    /**
     * 送达提交（带GPS校验）
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async deliverSubmitWithCheck({commit}, obj) {
      let resp = await deliverSubmitWithCheck(obj);
      commit('DELIVER_SUBMIT_WITH_CHECK', resp);
    },
    /**
     * 取消
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async cancelPlan({commit}, obj) {
      let resp = await cancelPlan(obj);
      commit('CANCEL_PLAN', resp);
    },
    /**
     * 导出
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    /**
     * 获取承运商下拉框数据
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getListCarrier({commit}, obj) {
      let resp = await getListCarrier(obj);
      commit('GET_LIST_CARRIER', resp);
    },
    //轨迹
    async orderTrajectory({commit}, obj){
      let resp = await orderTrajectory(obj);
      commit('ORDER_TRAJECTORY', resp);
    },
    /**
     * 获取车辆类型信息
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getCarTypeList({ commit }, obj) {
      let resp = await getCarTypeList(obj);
      commit('CAR_TYPE_LIST', resp);
    },
    /**
     * 预约排车的新增前置校验
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async planCreatePreCheck({ commit }, obj) {
      let resp = await planCreatePreCheck(obj);
      commit('ADD_VALIDATE_PARAM', resp);
    },
    //文件下载
    async fileDownLoad({commit}, obj) {
      let result = await fileDownLoad(obj);
      commit('FILE_DOWNLOAD', result);
    },
    //货主
    async getListShipper({ commit }, obj) {
      let resp = await listShipper(obj);
      commit('LIST_SHIPPER', resp);
    },

    //车牌颜色
    async listPlateColor({ commit }, obj) {
      let resp = await getPlateColor(obj);
      commit('LIST_PLATE_COLOR', resp);
    },
    //调度-订单查询数据
    async schedulingJobBillList({commit}, obj) {
      let resp = await schedulingJobBillList(obj);
      commit('SCHEDULING_JOB_BILL_LIST', resp);
    },
    //增加订单校验
    async appendAddSchOrder({commit}, obj) {
      let resp = await appendAddSchOrder(obj);
      commit('APPEND_ADD_SCH_ORDER', resp);
    },
    //查询计划装载量
    async scheduleInfoPlanOnload({commit}, obj) {
      let resp = await scheduleInfoPlanOnload(obj);
      commit('SCHEDULEINFO_PLAN_ONLOAD', resp);
    },
    /**
     * 重新计算汇总数据-调度
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async scheduTotalRefresh({commit}, obj) {
      let resp = await scheduTotalRefresh(obj);
      commit('SCHEDU_TOTAL_REFRESH', resp);
    },
    /**
     * 运输方式
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getListShipType({commit}, obj) {
      let resp = await getListShipType(obj);
      commit('GET_LIST_SHIP_TYPE', resp);
    },
    /**
     * 更改承运商初始化
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async updateCarrierInit({commit}, obj) {
      let resp = await updateCarrierInit(obj);
      commit('UPDATE_CARRIER_INIT', resp);
    },

    /**
     * 更改承运商提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async updateCarrierSubmit({commit}, obj) {
      let resp = await updateCarrierSubmit(obj);
      commit('UPDATE_CARRIER_SUBMIT', resp);
    },

    /**
     * 发运/送达日期校验
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async checkDispatchDeliverNeedConfirm({commit}, obj) {
      let resp = await checkDispatchDeliverNeedConfirm(obj);
      commit('CHECK_DISPATCH_DELIVER_NEED_CONFIRM', resp);
    },
  }
}
export default transportPlan



// WEBPACK FOOTER //
// ./src/page/transport/transportPlan/store/transportPlan.store.js